import Component from '@glimmer/component';
import { service } from '@ember/service';
import { array, hash } from '@ember/helper';
import { and, not, or } from 'ember-truth-helpers';
import {
  HdsLinkInline,
  HdsIcon,
} from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';
import optionForLocationLink from 'hcp/helpers/option-for-location-link';

/**
 *
 * `LocationLink` renders a Hds::Link::Inline component that uses a helper to
 *     get route, model, and query param args based on a HashiCorp link model.
 *
 * ```
 * <LocationLink
 *   @color="secondary"
 *   @hideIcon={{true}}
 *   @link={{link}}
 * />
 * ```
 *
 * @class LocationLink
 *
 */

/**
 * Any @color value that Hds supports for Link components.
 * @argument color
 * @type {string}
 */

/**
 * Flag to override default behavior by hiding icon.
 * @argument hideIcon
 * @type {boolean|any}
 */

/**
 * HashiCorp API link model to use when attempting to map to a UI route.
 * @argument link
 * @type {Object}
 */
export default class LocationLink extends Component {
  @service intl;
  <template>
    {{#let (optionForLocationLink @link) as |option|}}
      {{#let (and (not @hideIcon) option.icon) as |showIcon|}}
        {{#if option.route}}
          <HdsLinkInline
            @color={{or @color "primary"}}
            @icon={{if showIcon option.icon false}}
            @iconPosition="leading"
            @models={{if option.models option.models (array)}}
            @route={{option.route}}
            @query={{if option.query option.query (hash)}}
            ...attributes
            data-test-location-link-container
            data-test-location-link-anchor-container
          >
            {{~option.label}}
          </HdsLinkInline>
        {{else}}
          <Flex
            @alignItems="center"
            @direction="row"
            @display="inline"
            @gap="2xs"
            ...attributes
            data-test-location-link-container
            data-test-location-link-span-container
          >
            {{#if showIcon}}
              <HdsIcon
                @name={{option.icon}}
                @isInline={{true}}
                data-test-location-link-icon
              />
            {{/if}}
            <span>
              {{if @link.name @link.name @link.id}}
            </span>
          </Flex>
        {{/if}}
      {{/let}}
    {{/let}}
  </template>
}
